import React, { FC } from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import { CarePlanBundle } from '../../../../../types/FHIRTypes/Bundle'
import FhirLoader from '../../../../FhirLoader'
import { isCarePlanBundle } from '../../../../../typeGuards/fhirTypes'
import { CarePlanTable } from '@teschglobal/tg-fhir-react-components'
import { CarePlanDisplayType } from '../../../../../types/CarePlanDisplayType'

type CarePlanListProps = {
  carePlanData: CarePlanBundle;
  isFetching: boolean;
  handleChangePage: (page: number) => void
  totalPages: number;
  currentPage: number;
  displayType: CarePlanDisplayType;
}

const CarePlanList: FC<CarePlanListProps> = ({ carePlanData, handleChangePage, isFetching, totalPages, currentPage, displayType }) => {
  if (!isCarePlanBundle(carePlanData)) return null

  const patientCarePlans = carePlanData && carePlanData.entry ? carePlanData.entry.map((carePlan) => carePlan.resource) : []

  if (isFetching) {
    return <FhirLoader message="Loading..." />
  }

  return (
    <>
      {
        carePlanData?.total > 0 && (
          <div className='my-3 fw-bold'>
            <span role="status" aria-live="polite">{carePlanData?.total.toLocaleString()} record(s) found</span>
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
            />
          </div>
        )
      }
      <CarePlanTable
        displayMode={displayType}
        carePlans={patientCarePlans}
      />
      {
        carePlanData?.total > 0 && (
          <div className='my-3 fw-bold'>
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
            />
          </div>
        )
      }
    </>
  )
}

export default CarePlanList